module.exports = __webpack_public_path__ + "img/logo-m2n.0e6c65b0.svg";